import React from "react";
import Lottie from "react-lottie";
import "./Done_lottie.css";
import animationData from "./Done_lottie.json";

const Done_lottie = () => {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="Done_lottie_icon">
        <Lottie
          options={defaultOptions}
        />
      </div>
    </section>
  );
};

export default Done_lottie;